<article class="content">
  <h1>Privacy Policy</h1>

  <p>
    At {{appname}}, your privacy matters to us. This Privacy Policy explains how
    we collect, use, protect, and handle your personal information when you
    visit our website, create an account, log in, place an order, or contact us.
  </p>

  <p>
    By using our website, you agree to the practices described in this Privacy
    Policy.
  </p>

  <h2>Information We Collect</h2>

  <p>
    We may collect personal information that you provide to us directly when you
    use our website, including but not limited to:
  </p>

  <ul>
    <li>Your name</li>
    <li>Email address</li>
    <li>Shipping and billing address</li>
    <li>Phone number, if provided</li>
    <li>Order details and purchase history</li>
    <li>
      Messages or information you provide when contacting customer support
    </li>
  </ul>

  <p>
    If you create an account or log in using your email address, we collect the
    information needed to create and manage your account.
  </p>

  <h2>Google Login</h2>

  <p>
    Our website may allow you to log in using Google. If you choose to sign in
    with Google, we may receive basic account information from Google, such as
    your name, email address, and profile information made available through
    your Google account permissions.
  </p>

  <p>
    We use this information only to help you create or access your {{appname}}
    account, provide a smoother login experience, and manage your customer
    account on our website.
  </p>

  <p>
    We do not use Google login information for any unrelated purpose, and we do
    not sell or share your Google account information with third parties.
  </p>

  <h2>How We Use Your Information</h2>

  <p>We use the personal information we collect for the following purposes:</p>

  <ul>
    <li>To create and manage your customer account</li>
    <li>To process, confirm, and fulfill your orders</li>
    <li>To arrange shipping and delivery</li>
    <li>To provide customer support</li>
    <li>To process exchanges, refunds, or order-related requests</li>
    <li>To communicate with you about your account, orders, or inquiries</li>
    <li>To improve our website, services, and customer experience</li>
    <li>
      To help prevent fraud, unauthorized activity, or misuse of our website
    </li>
  </ul>

  <h2>Email Communications</h2>

  <p>
    We may use your email address to send you order confirmations, shipping
    updates, account-related notices, customer support responses, and other
    service-related communications.
  </p>

  <p>
    If you choose to subscribe to marketing emails, we may also send you updates
    about new arrivals, promotions, and brand news. You may unsubscribe from
    marketing emails at any time by following the unsubscribe instructions
    included in our emails.
  </p>

  <h2>Sharing of Information</h2>

  <p>
    We respect your privacy. We do not sell, rent, trade, or share your personal
    information with third parties for their marketing purposes.
  </p>

  <p>
    We may use trusted service providers only when necessary to operate our
    website and fulfill customer orders, such as payment processing, shipping,
    website hosting, security, analytics, or customer support tools. These
    service providers are permitted to use your information only as needed to
    provide services to us.
  </p>

  <p>
    We may also disclose information if required by law, legal process, or to
    protect the rights, safety, and security of {{appname}}, our customers, or
    others.
  </p>

  <h2>Payment Information</h2>

  <p>
    Payment information is processed securely by our payment service providers.
    {{appname}} does not store your full credit card number or full payment
    account details on our own servers.
  </p>

  <h2>Cookies and Website Data</h2>

  <p>
    Our website may use cookies and similar technologies to help the site
    function properly, remember your preferences, improve your shopping
    experience, analyze website performance, and support security features.
  </p>

  <p>
    You can choose to disable cookies through your browser settings. However,
    some website features may not function properly if cookies are disabled.
  </p>

  <h2>Data Security</h2>

  <p>
    We take reasonable measures to protect your personal information from
    unauthorized access, loss, misuse, alteration, or disclosure. However, no
    method of online transmission or electronic storage is completely secure,
    and we cannot guarantee absolute security.
  </p>

  <h2>Data Retention</h2>

  <p>
    We retain personal information for as long as necessary to provide our
    services, manage your account, fulfill orders, resolve disputes, comply with
    legal obligations, and maintain business records.
  </p>

  <h2>Your Privacy Choices</h2>

  <p>
    You may contact us to request access to, correction of, or deletion of your
    personal information, subject to applicable legal and business record
    requirements.
  </p>

  <p>
    You may also unsubscribe from marketing emails at any time by using the
    unsubscribe link in our emails or by contacting us directly.
  </p>

  <h2>Children's Privacy</h2>

  <p>
    Our website is not intended for children under the age of 13. We do not
    knowingly collect personal information from children under 13. If we become
    aware that we have collected personal information from a child under 13, we
    will take steps to delete such information.
  </p>

  <h2>Third-Party Links</h2>

  <p>
    Our website may contain links to third-party websites or services, such as
    social media platforms. We are not responsible for the privacy practices,
    content, or policies of third-party websites. We encourage you to review
    their privacy policies before providing any personal information.
  </p>

  <h2>Changes to This Privacy Policy</h2>

  <p>
    We may update this Privacy Policy from time to time. Any changes will be
    posted on this page with an updated effective date. Your continued use of
    our website after changes are posted means you accept the updated Privacy
    Policy.
  </p>

  <h2>Contact Us</h2>

  <p>
    If you have any questions about this Privacy Policy or how your personal
    information is handled, please contact us at:
  </p>

  <p>
    <strong>Email:</strong>
    <a href="mailto:{{email}}" target="_blank">{{email}}</a>
  </p>

  <p>
    <strong>Mailing Address:</strong><br />
    {{address1}}<br />
    {{address2}}<br />
    United States
  </p>
</article>
